import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { CHEVRON_DOWN, CLOSE, DOWNLOAD, UPLOAD } from "../../../assets";

import ButtonV2 from "../../../shared/components/buttonV2";
import useDropdown from "../../../utils-func/functions/usedropdown";
import { useQuery } from "react-query";
import {
  getJudicialDivisions,
  getLocalGovernment,
  getStates,
} from "../../../Services/services";
import { toast } from "react-hot-toast";
import { CreateCaseTypes, SearchHistoryTypes } from "../../../types";

import clsx from "clsx";
import Papa from "papaparse";

import { useAppSelector } from "../../../hooks";
import { selectEditMode } from "../../../states/slices/globalReducer";
import {
  editCase,
  createCase,
  courtStaffCsvUpload,
} from "../../../Services/court.services";
import { Tooltip } from "@mui/material";
import { propertyNames } from "../../../shared/components/caseformModal";

function CourtStaffCaseFormModal({
  open,
  close,
  onSuccess,
  existingCaseDetails,
}: {
  open: boolean;
  close: () => void;
  onSuccess: () => void;
  existingCaseDetails?: SearchHistoryTypes | null;
}) {
  const [step, setStep] = useState(1);
  const { setDropdowns, closeDropDown, dropdownRef, dropdowns } = useDropdown();

  const [formField, setFormField] = useState({
    title: "",
    title_number: "",
    survey_plan_number: "",
    owner_name: "",
    address: "",
    parties: "",
    subject_matter: "",
    suit_number: "",
    court_details: "",
    date_of_commencement: "",
    date_of_disposal: "",
    // name_of_parties: "",
    nature_of_case: "",
    reliefs_sought: "",
    judicial_division: "",
    description_of_properties: "",
  });
  const [uploadingFile, setUploadingFile] = useState(false);
  const uploadRef = useRef<HTMLInputElement | null>(null);
  const [rows, setRows] = useState<any>([]);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const editmode = useAppSelector(selectEditMode);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [selectedState, setSelectedState] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedLga, setSelectedLga] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedJudiciary, setSelectedJudiciary] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const { data: judicialDivision } = useQuery(
    ["division", 0],
    () => getJudicialDivisions(0),
    {
      refetchOnWindowFocus: false,
      enabled: open,
    },
  );
  const [errors, setErrors] = useState<any>(null);
  const [csvErrors, setCsvErrors] = useState<any>([]);
  const [tab, setTab] = useState("manual");
  const { data: states } = useQuery("states", getStates, {
    refetchOnWindowFocus: false,
    enabled: open,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const { data: lga } = useQuery(
    ["lga", currentPage],
    () => getLocalGovernment(currentPage),
    {
      refetchOnWindowFocus: false,
      enabled: open,
    },
  );

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value, name } = e.target;

    setFormField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target?.files && e.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     const bstr = event.target?.result;
  //     const workSheet = XLSX.read(bstr, { type: "binary" });
  //     const workSheetName = workSheet.SheetNames[0];
  //     const sheet = workSheet.Sheets[workSheetName];

  //     const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

  //     const headers = data[0];
  //     const values = data[1];

  //     const filledData = {};
  //     // @ts-ignore
  //     headers.forEach((header, index) => {
  //       // @ts-ignore
  //       filledData[header.toLowerCase()] = values[index];
  //     });

  //     setFormField((prev) => ({ ...prev, ...filledData }));
  //   };

  //   // @ts-ignore
  //   reader.readAsBinaryString(file);
  //   setStep(1);
  //   setTab("manual");
  // };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];

    if (!file) return;
    setUploadedFile(file);
    setUploadingFile(true);
    // Papa.parse(file, {
    //   header: true,
    //   skipEmptyLines: true,
    //   complete(results, file) {
    //     setRows(results?.data);
    //   },
    // });

    try {
      const formData = new FormData();

      formData.append("csv_file", file);

      const response = await courtStaffCsvUpload(formData, setProgress);
      if (response) {
        toast.success(response?.message);
        close();
        onSuccess();
        setUploadedFile(null);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setCsvErrors(error?.response?.data?.data);
    } finally {
      setUploadingFile(false);
    }
  };
  const handleUploadCase = async () => {
    if (errors) {
      setErrors(null);
    }
    setLoading(true);

    const payload: CreateCaseTypes = {
      title: formField.title || (selectedProperty?.name as string),
      title_number: formField.title_number,

      address: formField.address,
      survey_plan_number: formField.survey_plan_number,
      // owner_name: formField.owner_name,
      // name_of_parties: formField.name_of_parties,
      subject_matter: formField.subject_matter,
      description_of_properties: formField.description_of_properties,
      suit_number: formField.suit_number,
      court_details: formField.court_details,
      parties: formField.parties,
      date_of_commencement: formField.date_of_commencement,
      nature_of_case: formField.nature_of_case,
      date_of_disposal: formField.date_of_disposal,
      status: selectedStatus,
      lga_id: selectedLga?.id,
      judicial_division_id: selectedJudiciary?.id,
      reliefs_sought: formField.reliefs_sought,
      state_id: selectedState?.id,
    };

    try {
      const response = editmode
        ? await editCase(payload, existingCaseDetails?.id)
        : await createCase(payload);
      if (response) {
        onSuccess();
        setFormField({
          title: "",
          title_number: "",
          survey_plan_number: "",
          owner_name: "",
          address: "",
          parties: "",
          subject_matter: "",
          suit_number: "",
          court_details: "",
          date_of_commencement: "",
          date_of_disposal: "",
          // name_of_parties: "",
          nature_of_case: "",
          reliefs_sought: "",
          judicial_division: "",
          description_of_properties: "",
        });
        setSelectedStatus("");

        setSelectedJudiciary(null);
        setSelectedLga(null);
        setSelectedState(null);
        setStep(1);
        close();
        onSuccess();
      }
    } catch (error: any) {
      if (error?.response?.status === 422) {
        toast.error("Oops!, something is missing");
        setErrors(error?.response?.data?.errors);
      } else {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };
  const [selectedProperty, setSelectedProperty] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    if (existingCaseDetails) {
      setFormField({
        title: existingCaseDetails.title,
        title_number: existingCaseDetails.title_number,
        survey_plan_number: existingCaseDetails.survey_plan_number,
        owner_name: existingCaseDetails.owner_name,
        address: existingCaseDetails.address,
        parties: existingCaseDetails.parties,
        subject_matter: existingCaseDetails.subject_matter,
        suit_number: existingCaseDetails.suit_number,
        court_details: existingCaseDetails.court_details,
        date_of_commencement: existingCaseDetails.date_of_commencement,
        date_of_disposal: existingCaseDetails.date_of_disposal,
        // name_of_parties: existingCaseDetails.name_of_parties,
        nature_of_case: existingCaseDetails.nature_of_case,
        reliefs_sought: existingCaseDetails?.reliefs_sought,
        judicial_division: "",
        description_of_properties:
          existingCaseDetails.description_of_properties,
      });
      setSelectedStatus(existingCaseDetails.status);
    } else {
      reset();
    }
  }, [existingCaseDetails]);

  const reset = () => {
    setFormField({
      title: "",
      title_number: "",
      survey_plan_number: "",
      owner_name: "",
      address: "",
      parties: "",
      subject_matter: "",
      suit_number: "",
      court_details: "",
      date_of_commencement: "",
      date_of_disposal: "",
      // name_of_parties: "",
      nature_of_case: "",
      reliefs_sought: "",
      judicial_division: "",
      description_of_properties: "",
    });
    close();
    setSelectedStatus("");
  };

  const handleDownloadDoc = (url: string) => {
    const fileName = url.split(".")[1];
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
  };
  useEffect(() => {
    if (selectedRow) {
      setSelectedJudiciary({
        id: selectedRow.judicial_division_id,
        name: judicialDivision?.find(
          (item: any) => item.id === Number(selectedRow.judicial_division_id),
        )?.name,
      });
      setSelectedLga({
        id: selectedRow.lga_id,
        name: lga?.find((item: any) => item.id === Number(selectedRow.lga_id))
          ?.name,
      });
      setSelectedState({
        id: selectedRow.state_id,
        name: states?.find(
          (item: any) => item.id === Number(selectedRow.state_id),
        )?.name,
      });
      setSelectedStatus(selectedRow.status);
    }
  }, [selectedRow]);

  return (
    <>
      <div
        className={`w-full h-full fixed ${
          open ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[600px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-lightGold rounded-xl p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                {editmode ? "Edit" : "Upload"} Case - Property Details
              </h2>
              <button
                onClick={reset}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>
            <div className="w-full bg-[#E9EAEB] rounded h-[2.5px] overflow-hidden mb-6">
              <div
                className="h-full bg-globalGold transition-all duration-700 ease-in-out"
                style={{
                  width: `${(step / 2) * 100}%`,
                }}
              />
            </div>
            <div className="w-full px-4">
              <div className="w-full  flex items-center gap-x-3 p-3 bg-lightGold rounded-xl mt-2 ">
                <button
                  onClick={() => setTab("manual")}
                  className={clsx(
                    "w-full px-5 py-2 text-sm text-[#656F7D] rounded-lg ",
                    tab === "manual" && "text-globalGold shadow-blur bg-white",
                  )}
                >
                  Manual Entry
                </button>
                <button
                  onClick={() => setTab("csv")}
                  className={clsx(
                    "w-full  px-5 py-2 text-sm text-[#656F7D] rounded-lg ",
                    tab === "csv" && "text-globalGold shadow-blur bg-white",
                  )}
                >
                  CSV Upload
                </button>
              </div>
            </div>

            {step === 1 && tab === "manual" && (
              <div className="flex flex-col custom-scrollbar gap-y-4 w-full p-4 h-[300px] overflow-y-scroll">
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Property Title <span className="text-red-500">*</span>
                    </span>

                    {selectedProperty?.id === propertyNames.length ? (
                      <input
                        type="text"
                        name="title"
                        value={formField.title}
                        onChange={handleInputChange}
                        autoFocus
                        className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                        placeholder="Enter Property Title"
                      />
                    ) : (
                      <>
                        <div
                          onClick={() =>
                            setDropdowns({ ...dropdowns, property: true })
                          }
                          className="flex items-center justify-between  gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                        >
                          <input
                            type="text"
                            placeholder="Select property title"
                            value={selectedProperty?.name}
                            className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                          />

                          <img
                            src={CHEVRON_DOWN}
                            className="w-[20px] h-[20px]"
                            alt=""
                          />
                        </div>
                        {propertyNames.length > 0 && dropdowns.property && (
                          <div
                            ref={dropdownRef.property}
                            className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                          >
                            {propertyNames?.map((item) => (
                              <span
                                key={item.id}
                                onClick={() => {
                                  setSelectedProperty(item);
                                  closeDropDown("property");
                                }}
                                className="px-4 py-2 text-start text-nowrap text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                              >
                                {item.name}
                              </span>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    <span className="text-xs text-red-500">
                      {errors?.title && errors?.title[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Title Number
                    </span>
                    <input
                      type="text"
                      name="title_number"
                      value={formField.title_number}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter title number"
                    />
                    {/* <span className="text-xs text-red-500">
                      {errors?.title_number && errors?.title_number[0]}
                    </span> */}
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Location of Property{" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      value={formField.address}
                      onChange={handleInputChange}
                      name="address"
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Location of Property"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.address && errors?.address[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Survey Plan Number
                    </span>
                    <input
                      type="text"
                      name="survey_plan_number"
                      value={formField.survey_plan_number}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Plan Number"
                    />
                    {/* <span className="text-xs text-red-500">
                      {errors?.survey_plan_number &&
                        errors?.survey_plan_number[0]}
                    </span> */}
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  {/* <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Property Owner Name{" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="owner_name"
                      onChange={handleInputChange}
                      value={formField.owner_name}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Owner Name"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.owner_name && errors?.owner_name[0]}
                    </span>
                  </div> */}
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Parties to the Suit (add , to differentiate){" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="parties"
                      value={formField.parties}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter parties to suit"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.parties && errors?.parties[0]}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  {/* <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Name of Parties (add , to differentiate){" "}
                      <span className="text-red-500">*</span>{" "}
                    </span>
                    <input
                      type="text"
                      name="name_of_parties"
                      value={formField.name_of_parties}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g John Doe, Jane Doe"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.name_of_parties && errors?.name_of_parties[0]}
                    </span>
                  </div> */}
                  <div className="w-full flex flex-col gap-y-2 relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      States <span className="text-red-500">*</span>
                    </span>
                    <div
                      onClick={() =>
                        setDropdowns({ ...dropdowns, state: true })
                      }
                      className="flex items-center justify-between  gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                    >
                      <input
                        type="text"
                        placeholder="Enter state"
                        value={selectedState?.name}
                        className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                      />
                      {/* <span className="text-sm font-medium text-customDark">
                                          {selectedState?.name || "Enter state"}
                                        </span> */}
                      <img
                        src={CHEVRON_DOWN}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />
                    </div>
                    {states?.length > 0 && dropdowns.state && (
                      <div
                        ref={dropdownRef.state}
                        className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                      >
                        {states?.map((item: { id: number; name: string }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedState(item);
                              closeDropDown("state");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        ))}
                      </div>
                    )}
                    <span className="text-xs text-red-500">
                      {errors?.state_id && errors?.state_id[0]}
                    </span>
                  </div>
                </div>
                <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Local Government Area (LGA){" "}
                    <span className="text-red-500">*</span>
                  </span>
                  <div
                    onClick={() => {
                      if (!selectedState) {
                        toast.error("Select a state");
                        return;
                      }
                      setDropdowns({ ...dropdowns, lga: true });
                    }}
                    className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      value={selectedLga?.name}
                      placeholder="Select state first"
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />
                    {/* <span className="text-sm font-medium text-customDark">
                                                       {selectedLga?.name || "Enter local govt area (LGA)"}
                                                     </span> */}
                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {lga?.data?.length > 0 && dropdowns.lga && (
                    <div
                      ref={dropdownRef.lga}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {lga?.data?.map(
                        (item: {
                          id: number;
                          name: string;
                          state_id: number;
                          created_at: string;
                          updated_at: string;
                        }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedLga(item);
                              closeDropDown("lga");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        ),
                      )}
                      <div className="flex items-center gap-x-2 justify-center">
                        <Tooltip title="Previous">
                          <button
                            onClick={() =>
                              setCurrentPage(lga?.meta?.current_page - 1)
                            }
                            disabled={lga?.meta?.current_page === 1}
                            className={`w-[30px] h-[30px] rotate-180 hover:bg-gray-100 rounded-full flex items-center justify-center ${
                              lga?.meta?.current_page === 1 &&
                              "cursor-not-allowed"
                            }`}
                          >
                            <img src={CHEVRON_DOWN} alt="" />
                          </button>
                        </Tooltip>
                        <Tooltip title="Next">
                          <button
                            onClick={() =>
                              setCurrentPage(lga?.meta?.current_page + 1)
                            }
                            disabled={
                              lga?.meta?.current_page === lga?.meta?.last_page
                            }
                            className={`w-[30px] h-[30px] hover:bg-gray-100 rounded-full flex items-center justify-center ${
                              lga?.meta?.current_page ===
                                lga?.meta?.last_page && "cursor-not-allowed"
                            }`}
                          >
                            <img src={CHEVRON_DOWN} alt="" />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                  <span className="text-red-500 text-xs">
                    {errors?.lga_id && errors?.lga_id[0]}
                  </span>
                </div>
                {/* <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Judicial Division <span className="text-red-500">*</span>
                  </span>
                  <div
                    onClick={() => {
                      setDropdowns({ ...dropdowns, judicial: true });
                    }}
                    className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      value={selectedJudiciary?.name}
                      placeholder="Enter judicial division"
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />

                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {judicialDivision?.length > 0 && dropdowns.judicial && (
                    <div
                      ref={dropdownRef.judicial}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {judicialDivision?.map(
                        (item: {
                          id: number;
                          name: string;

                          created_at: string;
                          updated_at: string;
                        }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedJudiciary(item);
                              closeDropDown("judicial");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        )
                      )}
                    </div>
                  )}
                  <span className="text-xs text-red-500">
                    {errors?.judicial_division_id &&
                      errors?.judicial_division_id[0]}
                  </span>
                </div> */}
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Description of Properties{" "}
                    <span className="text-red-500">*</span>
                  </span>
                  <textarea
                    rows={4}
                    onChange={handleInputChange}
                    name="description_of_properties"
                    value={formField.description_of_properties}
                    className="w-full resize-none border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter detailed description of the properties involved"
                  />
                  <span className="text-xs text-red-500">
                    {errors?.description_of_properties &&
                      errors?.description_of_properties[0]}
                  </span>
                </div>
              </div>
            )}
            {step === 2 && tab === "manual" && (
              <div className="flex flex-col w-full gap-y-4 p-4 h-[300px] overflow-y-scroll">
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Suit Number  <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      value={formField.suit_number}
                      name="suit_number"
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. SN2023/001"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.suit_number && errors?.suit_number[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Nature of Dispute  {" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="nature_of_case"
                      value={formField.nature_of_case}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. Land Dispute, Ownership "
                    />
                    <span className="text-xs text-red-500">
                      {errors?.nature_of_case && errors?.nature_of_case[0]}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Court and Judicial Division{" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="court_details"
                      value={formField.court_details}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. High Court Lagos"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.court_details && errors?.court_details[0]}
                    </span>
                  </div>
                  <div className="w-full flex flex-col gap-y-2 relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Status of Dispute <span className="text-red-500">*</span>
                    </span>
                    <div
                      onClick={() => {
                        setDropdowns({ ...dropdowns, status: true });
                      }}
                      className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                    >
                      <input
                        type="text"
                        value={selectedStatus}
                        placeholder="Status"
                        className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                      />
                      {/* <span className="text-sm font-medium text-customDark">
                                                         {selectedLga?.name || "Enter local govt area (LGA)"}
                                                       </span> */}
                      <img
                        src={CHEVRON_DOWN}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />
                    </div>
                    {dropdowns.status && (
                      <div
                        ref={dropdownRef.status}
                        className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                      >
                        {["pending", "ongoing", "concluded"].map((item) => (
                          <span
                            key={item}
                            onClick={() => {
                              setSelectedStatus(item);
                              closeDropDown("status");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    )}
                    <span className="text-xs text-red-500">
                      {errors?.status && errors?.status[0]}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Relief Sought
                  </span>
                  <input
                    type="text"
                    value={formField.reliefs_sought}
                    onChange={handleInputChange}
                    name="reliefs_sought"
                    className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter Reliefs Sought"
                  />
                  <span className="text-red-500 text-xs">
                    {errors?.reliefs_sought && errors?.reliefs_sought[0]}
                  </span>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Date of Commencement {" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="date"
                      name="date_of_commencement"
                      value={formField.date_of_commencement}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Owner Name"
                    />
                    <span className="text-xs text-red-500">
                      {errors?.date_of_commencement &&
                        errors?.date_of_commencement[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Date of Disposal 
                    </span>
                    <input
                      type="date"
                      name="date_of_disposal"
                      onChange={handleInputChange}
                      value={formField.date_of_disposal}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter title number"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Subject Matter  <span className="text-red-500">*</span>
                  </span>
                  <textarea
                    rows={4}
                    name="subject_matter"
                    onChange={handleInputChange}
                    value={formField.subject_matter}
                    className="w-full resize-none border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter the subject matter of the case"
                  />
                  <span className="text-xs text-red-500">
                    {errors?.subject_matter && errors?.subject_matter[0]}
                  </span>
                </div>
              </div>
            )}
            {tab === "csv" && (
              <>
                {uploadingFile ? (
                  uploadedFile && (
                    <div className="mt-4 p-5">
                      <div className="text-sm text-gray-700 font-medium">
                        {uploadedFile.name}
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                        <div
                          className="bg-globalGold h-2.5 rounded-full transition-all duration-300"
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                      {progress === 100 && (
                        <p className="text-green-600 flex text-center justify-center text-sm mt-1">
                          Upload complete
                        </p>
                      )}
                    </div>
                  )
                ) : csvErrors?.length > 0 ? (
                  <div className="p-5">
                    <div className="max-h-64  overflow-y-auto mt-4 border rounded-md border-red-200">
                      <table className="min-w-full text-sm text-left">
                        <thead className="bg-red-50 text-red-700 font-medium border-b border-red-200">
                          <tr>
                            <th className="px-4 py-2">Row</th>
                            <th className="px-4 py-2">Status</th>
                            <th className="px-4 py-2">Errors</th>
                          </tr>
                        </thead>
                        <tbody>
                          {csvErrors.map((rowError: any, index: number) => (
                            <tr
                              key={index}
                              className="border-b last:border-none"
                            >
                              <td className="px-4 py-2 font-medium text-gray-700">
                                Row {rowError.row}
                              </td>
                              <td className="px-4 py-2 capitalize text-red-600">
                                {rowError.status}
                              </td>
                              <td className="px-4 py-2">
                                <ul className="list-disc list-inside text-gray-700 space-y-1">
                                  {rowError.errors.map(
                                    (err: any, idx: number) => (
                                      <li key={idx}>{err}</li>
                                    ),
                                  )}
                                </ul>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="w-full px-4 py-4 flex items-center gap-x-2">
                    <div
                      onClick={() => uploadRef?.current?.click()}
                      className="w-full flex flex-col justify-center cursor-pointer items-center p-10 gap-y-1 rounded-xl border border-dotted border-globalGold bg-lightGold "
                    >
                      <img src={UPLOAD} className="w-[40px] h-[40px]" alt="" />
                      <span className="text-[#4F5762] font-medium text-sm">
                        Click here to upload csv file
                      </span>
                      <span className="text-xs font-normal text-[#808080]">
                        csv, txt up to 5MB
                      </span>
                    </div>
                    <input
                      type="file"
                      ref={uploadRef}
                      accept=".csv, .xlsx"
                      onChange={handleFileUpload}
                      className="sr-only"
                    />
                    <div
                      onClick={() =>
                        handleDownloadDoc("/Lispendes-csv-template.csv")
                      }
                      className="w-full flex flex-col cursor-pointer gap-y-1 items-center justify-center p-10 rounded-xl border border-dotted border-globalGold bg-lightGold "
                    >
                      <img
                        src={DOWNLOAD}
                        className="w-[40px] h-[40px]"
                        alt=""
                      />
                      <span className="text-[#4F5762] font-medium text-center text-sm">
                        Click here to download csv template
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="flex items-end justify-end gap-x-3 p-8">
              {step === 2 && tab === "manual" && (
                <ButtonV2
                  title={"Back"}
                  btnStyle={
                    "w-fit h-fit  px-7 py-2 rounded-xl border border-borderColor"
                  }
                  textStyle={"text-sm font-medium text-customDark "}
                  handleClick={() => setStep((prev) => prev - 1)}
                />
              )}
              {tab === "manual" ? (
                <ButtonV2
                  title={step === 2 ? "Submit" : "Next"}
                  loading={loading}
                  loaderColor="#ffffff"
                  btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                  textStyle={"text-sm font-medium text-white "}
                  handleClick={() => {
                    if (step === 2) {
                      handleUploadCase();
                    } else {
                      setStep((prev) => prev + 1);
                    }
                  }}
                />
              ) : (
                csvErrors?.length > 0 && (
                  <ButtonV2
                    title={"Cancel"}
                    btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                    textStyle={"text-sm font-medium text-white "}
                    handleClick={() => setCsvErrors([])}
                  />
                )
              )}
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
}

export default CourtStaffCaseFormModal;
